import { render, staticRenderFns } from "./PrintDistributionAmountsTable.vue?vue&type=template&id=3efc35b8&"
import script from "./PrintDistributionAmountsTable.vue?vue&type=script&lang=js&"
export * from "./PrintDistributionAmountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports